export const GET_WORK_ITEM_ALERTS_FETCH_START =
  "GET_WORK_ITEM_ALERTS_FETCH_START";
export const GET_WORK_ITEM_ALERTS_FETCH_SUCCESS =
  "GET_WORK_ITEM_ALERTS_FETCH_SUCCESS";
export const GET_WORK_ITEM_ALERTS_FETCH_ERROR =
  "GET_WORK_ITEM_ALERTS_FETCH_ERROR";

const initialState = {};

/**
 *
 * @param state - {alerts:[{alertDefinition}]}
 * @param action
 * @returns {{}}
 */
export const workItemAlertsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORK_ITEM_ALERTS_FETCH_START:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case GET_WORK_ITEM_ALERTS_FETCH_SUCCESS:
      return {
        alerts: action.payload,
        error: null,
        loading: false,
      };
    case GET_WORK_ITEM_ALERTS_FETCH_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/mySCC/common/reducers/WorkItemAlertsReducer.js